import type { NavigateFunction } from 'react-router-dom'

export function getPropertyEditReactPath(propertyId: string | number): string {
  return `/property/edit/${propertyId}`
}

/** Href for property edit links. */
export function getPropertyEditUrl(propertyId: string | number): string {
  return getPropertyEditReactPath(propertyId)
}

export function navigateToPropertyEdit(
  navigate: NavigateFunction,
  propertyId: string | number,
): void {
  navigate(getPropertyEditReactPath(propertyId))
}
